import React, { Fragment ,useState } from 'react'
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import img1 from '../../img/resultado/Imagen_1.jpg';
import img2 from '../../img/resultado/Imagen_2.jpg';
import img3 from '../../img/resultado/Imagen_3.jpg';
import img4 from '../../img/resultado/Imagen_4.jpg';
import img5 from '../../img/resultado/Imagen_5.jpg';
import img6 from '../../img/resultado/Imagen_6.jpg';
import img7 from '../../img/resultado/Imagen_7.jpg';
import img8 from '../../img/resultado/Imagen_8.jpg';
import img9 from '../../img/resultado/Imagen_9.jpg';
import img10 from '../../img/resultado/Imagen_10.jpg';
import img11 from '../../img/resultado/Imagen_11.jpg';



const Resultado = () => {
    const [state, setstate] = useState({
        photoIndex: 0,
        isOpen: false
    });
    
    const images = [ img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11 ];
    
    const resultado = (a) => { 
        setstate({ isOpen: true, photoIndex: a })
    }
    
    return ( 
        <Fragment>
        <div className="contenedor resultado">
            <div className="resumen">
                <h5 className="titulo">Resultado</h5>
                <span className="resuladospan"></span>
            </div>
            <div className="parrafo">
                <p>En las siguientes imágenes se presentan algunos resultados de secciones de la ciudad, el caso de estudio fue Mérida, Yucatán México. En estas imágenes en donde se puede observar cómo funciona el algoritmo de delimitación. Como podemos apreciar son varios casos y en ellos se observa como se delimita de forma correcta varios techos, la exactitud del algoritmo es del 87%, cabe decir que la sección del aeropuerto es el caso especial dado que asfalto de la pista y el techo son parecidos, aunque tambien para el ojo humano es difícil de comparar debido a que las texturas son similares, gracias a estas muestras de retroalimentación se siguen perfeccionando el algoritmo de delimitación. </p>
            </div>
            <div className="imagenes"> 
                <img src={require("../../img/resultado/Imagen_1.jpg")} alt="muestra 1"  className="img-resutaldo"  onClick={() => (resultado(0))}  />
                <img src={require("../../img/resultado/Imagen_2.jpg")} alt="muestra 2"  className="img-resutaldo"  onClick={() => (resultado(1))}  />
                <img src={require("../../img/resultado/Imagen_3.jpg")} alt="muestra 3"  className="img-resutaldo"  onClick={() => (resultado(2))}  />
                <img src={require("../../img/resultado/Imagen_4.jpg")} alt="muestra 4"  className="img-resutaldo"  onClick={() => (resultado(3))}  />
                <img src={require("../../img/resultado/Imagen_5.jpg")} alt="muestra 5"  className="img-resutaldo"  onClick={() => (resultado(4))}  />
                <img src={require("../../img/resultado/Imagen_6.jpg")} alt="muestra 6"  className="img-resutaldo"  onClick={() => (resultado(5))}  />
                <img src={require("../../img/resultado/Imagen_7.jpg")} alt="muestra 7"  className="img-resutaldo"  onClick={() => (resultado(6))}  />
                <img src={require("../../img/resultado/Imagen_8.jpg")} alt="muestra 8"  className="img-resutaldo"  onClick={() => (resultado(7))}  />
                <img src={require("../../img/resultado/Imagen_9.jpg")} alt="muestra 9"  className="img-resutaldo"  onClick={() => (resultado(8))}  />
                <img src={require("../../img/resultado/Imagen_10.jpg")} alt="muestra 10"  className="img-resutaldo"  onClick={() => (resultado(9))}  />
                <img src={require("../../img/resultado/Imagen_11.jpg")}  alt="muestra 11" className="img-resutaldo"  onClick={() => (resultado(10))}  />
            </div>
        </div>
        {state.isOpen && (
            <Lightbox
              // imageTitle ={images[(state.photoIndex)]} 
              discourageDownloads={false}
              mainSrc={images[(state.photoIndex)]}
              nextSrc={images[(state.photoIndex + 1) % images.length]}
              prevSrc={images[(state.photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setstate({ ...state , isOpen: false })}
              onMovePrevRequest={() =>
                setstate({
                  ...state,
                  photoIndex: (state.photoIndex + images.length - 1) % images.length
                })
              }
              onMoveNextRequest={() =>
                setstate({
                  ...state,
                  photoIndex: (state.photoIndex + 1) % images.length
                })
              }
            />
        )}
    </Fragment>
     );
}
 
export default Resultado;